export const productUnitsMap = {
  '2JEu4U11Zg5ryT5pDL4q': [{ value: 1, unit: 'l', label: '1 liter' }],

  '50wpq535YdzqEUMjAXvs': [{ value: 5, unit: 'l', label: '5 liter' }],

  '88MaibBYhZbiNHbTiCnV': [
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  DdUfiOCUz8ivDb2hHAS4: [
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  EFHtddVRvlEGGXZvZtxe: [
    { value: 1, unit: 'l', label: '1 liter' },
    { value: 5, unit: 'l', label: '5 liter' },
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  FTYRAnmuERiWl2Zdnt7u: [
    { value: 200, unit: 'kg', label: '200 kg' },
    // { value: 1000, unit: 'kg', label: '1000 kg' },
  ],

  JVMhBRZktrE1SMBzMQsG: [
    { value: 1, unit: 'l', label: '1 liter' },
    { value: 5, unit: 'l', label: '5 liter' },
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  Obmt9nemJV0H9we37kRX: [
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  R3zPzU7plaRC7EpwQgPN: [
    { value: 1, unit: 'l', label: '1 liter' },
    { value: 5, unit: 'l', label: '5 liter' },
  ],

  fU7z9iCuYzTgwRinLNXw: [
    { value: 1, unit: 'l', label: '1 liter' },
    { value: 5, unit: 'l', label: '5 liter' },
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  hUkSwgyT0YKynkv5YvXC: [
    { value: 1, unit: 'l', label: '1 liter' },
    { value: 5, unit: 'l', label: '5 liter' },
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  p2kUOLhR2s4HTubagy8U: [
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 220, unit: 'l', label: '220 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],

  pdwMwqar2s4YtPt7TaBj: [
    { value: 25, unit: 'l', label: '25 liter' },
    { value: 100, unit: 'l', label: '100 liter' },
    { value: 1000, unit: 'l', label: '1000 liter' },
  ],
  ubbc: [{ value: 150, unit: 'kg', label: '150 kg' }],
  '8TCdSKtmpWfmeagjJj4v': [{ value: 5, unit: 'l', label: '5 liter' }],
  dosering: [{ value: 1, unit: 'stk', label: '1 stk' }],
  levelsensor: [{ value: 1, unit: 'stk', label: '1 stk' }],
  sensor: [{ value: 1, unit: 'stk', label: '1 stk' }],
  gps: [{ value: 1, unit: 'stk', label: '1 stk' }],
  aksBW: [{ value: 5, unit: 'l', label: '5 liter' }],
  brightwater: [{ value: 5, unit: 'l', label: '5 liter' }],
  dustmeasurements: [{ value: 1, unit: 'stk', label: '1 stk' }],
  'fryse-sand': [{ value: 20, unit: 'kg', label: '20 kg' }],
};
